/**
 * @generated SignedSource<<268c5eeeb9b7af171142ba0b3c3d9556>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type applyRefundMutation$variables = {
  accountNo: string;
  accountOwner: string;
  autographImageKey?: string | null | undefined;
  bank: string;
  delegationFileKey?: string | null | undefined;
  metaProperties?: string | null | undefined;
  phoneNumber: string;
  refundId: string;
  utmCampaign?: string | null | undefined;
  utmContent?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmSource?: string | null | undefined;
  utmTerm?: string | null | undefined;
};
export type applyRefundMutation$data = {
  readonly applyRefund: {
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type applyRefundMutation = {
  response: applyRefundMutation$data;
  variables: applyRefundMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountNo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountOwner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autographImageKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bank"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "delegationFileKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metaProperties"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumber"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmCampaign"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmContent"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmMedium"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmSource"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmTerm"
},
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountNo",
        "variableName": "accountNo"
      },
      {
        "kind": "Variable",
        "name": "accountOwner",
        "variableName": "accountOwner"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "campaign",
            "variableName": "utmCampaign"
          },
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "utmContent"
          },
          {
            "kind": "Variable",
            "name": "medium",
            "variableName": "utmMedium"
          },
          {
            "kind": "Variable",
            "name": "source",
            "variableName": "utmSource"
          },
          {
            "kind": "Variable",
            "name": "term",
            "variableName": "utmTerm"
          }
        ],
        "kind": "ObjectValue",
        "name": "applyUtm"
      },
      {
        "kind": "Variable",
        "name": "autographImageKey",
        "variableName": "autographImageKey"
      },
      {
        "kind": "Variable",
        "name": "bank",
        "variableName": "bank"
      },
      {
        "kind": "Variable",
        "name": "delegationFileKey",
        "variableName": "delegationFileKey"
      },
      {
        "kind": "Variable",
        "name": "metaProperties",
        "variableName": "metaProperties"
      },
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      },
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "ApplyRefundOutput",
    "kind": "LinkedField",
    "name": "applyRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "applyRefundMutation",
    "selections": (v13/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "applyRefundMutation",
    "selections": (v13/*: any*/)
  },
  "params": {
    "cacheID": "a1103c7bad025cee46fb30d2f0ff01bb",
    "id": null,
    "metadata": {},
    "name": "applyRefundMutation",
    "operationKind": "mutation",
    "text": "mutation applyRefundMutation(\n  $refundId: String!\n  $phoneNumber: String!\n  $bank: String!\n  $accountOwner: String!\n  $accountNo: String!\n  $metaProperties: String\n  $autographImageKey: String\n  $delegationFileKey: String\n  $utmSource: String\n  $utmMedium: String\n  $utmCampaign: String\n  $utmTerm: String\n  $utmContent: String\n) {\n  applyRefund(refundId: $refundId, phoneNumber: $phoneNumber, bank: $bank, accountOwner: $accountOwner, accountNo: $accountNo, metaProperties: $metaProperties, autographImageKey: $autographImageKey, delegationFileKey: $delegationFileKey, applyUtm: {source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent}) {\n    result\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "657af716dd0b5c7b51a9cad6633bb0cc";

export default node;
